import React, { useState } from "react";
import { FormButton, SpinnerOverlay } from "components";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import { RNHAgenteAsignarDo } from "services/services-mia/programa-salud/personal/RNHAgenteAsignarDo";
import styles from "./DesasignarModal.module.scss";

/**
 * Confirmación para sacar a un agente de uno de sus lugares.
 *
 * No hay un servicio propio: es RNHAgenteAsignarDo mandando el id y la versión del
 * lugar Y NADA MÁS. Cualquier dato adicional lo convierte en una modificación.
 *
 * Por eso el modal existe: la acción es irreversible desde la UI —para volver atrás
 * hay que asignar de nuevo, eligiendo hospital y componente otra vez— y el gesto que
 * la dispara es un botón al lado de una grilla, fácil de tocar sin querer.
 *
 * El ESTADO del agente no se toca: sigue Activo, simplemente con un lugar menos.
 */
export default function DesasignarModal({
  row,
  datosAgente,
  asignacion,
  updateList,
  limpiarSeleccion,
  closeModal,
}) {
  const credentials = useRecoilValue(userCredentials);
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const [inRequest, setInRequest] = useState(false);

  const desasignar = async (e) => {
    e.preventDefault();
    setInRequest(true);

    const respuesta = await RNHAgenteAsignarDo(credentials, {
      agenteId: datosAgente?.rnhAgenteId ?? row?.id,
      lugarId: asignacion?.id,
      lugarVersion: asignacion?.version,
    });
    setInRequest(false);

    if (!respuesta.ok) return;

    setSnackBarInfo({
      message: "Agente desasignado correctamente",
      severity: "success",
      open: true,
    });
    limpiarSeleccion?.();
    updateList?.();
    closeModal?.();
  };

  return (
    <form className={styles.contenedor} onSubmit={desasignar} noValidate>
      <p className={styles.texto}>
        Vas a sacar a <strong>{row?.apellidosNombres}</strong> de{" "}
        <strong>{asignacion?.lugar}</strong>.
      </p>
      <p className={styles.aclaracion}>
        Queda sin componente asignado. Su estado no cambia y se lo puede volver a
        asignar cuando haga falta.
      </p>

      <FormButton
        inRequest={inRequest}
        newFormData={{ button: "Desasignar" }}
        onCloseModal={closeModal}
      />
      {inRequest && <SpinnerOverlay />}
    </form>
  );
}
